

















import {ref, reactive, computed, defineComponent, PropType} from '@vue/composition-api'
import {AnyParam, isAnimatedParam} from '@/params'

export default defineComponent({
  name: 'ParamKeyframeIcon',
  props: {
    param: {
      type: Object as PropType<AnyParam>,
      required: true
    }
  },
  setup(props, context) {
    const animatable = computed(() => {
      return isAnimatedParam(props.param)
    })

    /** We consider a param animated if it has two or more keyframes. */
    const isAnimated = computed(() => {
      if (!(isAnimatedParam(props.param)))
        return false
      return props.param.keyframeList.getNumKeyframes() >= 2
    })

    /** is the current time at a keyframe for this param? */
    const atKeyframe = computed(() => {
      const param = props.param
      return isAnimatedParam(param) && param.atKeyframe()
    })

    // status for tooltip
    const keyframeStatus = computed(() => {
      if (atKeyframe.value)
        return "Delete this keyframe"
      else
        return "Add keyframe"
    })

    const toggleKeyframe = () => {
      context.emit('toggleKeyframe')
    }

    return {animatable, isAnimated, atKeyframe, toggleKeyframe, keyframeStatus}
  }
})
